<template>
    <div class="home">
        <div class="banner_box" style="width: 100%;">
            <el-carousel trigger="click" height="480px" :autoplay="true" :interval="5000" arrow="never" indicator-position="none">
                <el-carousel-item v-for="(item, index) in imgList" :key="index">
                    <!--<a href="/certificate" v-if="index == 1"><img :src="item.src" alt="轮播图"/></a>-->
                    <img :src="item.src" alt="" />
                    <!--<a :href="index === 1 ? '/certificate' : 'javascript:;'" :style="{background: 'url('+ item.src +')',backgroundPosition: 'center center',backgroundSize:'cover',backgroundRepeat:'no-repeat'}"></a>-->
                </el-carousel-item>
            </el-carousel>
            <div class="home_label">
                <div class="label width clearfix">
                    <div class="label_item white_color p_l2">
                        <!-- <span class="font_14">用户量</span> -->
                        <p class="font_14">用户量</p>
                        <p class="font_14">{{count.allUserTotal}}</p>
                    </div>
                    <div class="label_item white_color p_l2">
                        <p class="font_14">企业入驻</p>
                        <p class="font_14">{{count.enterpriseTotal}}</p>
                    </div>
                    <div class="label_item white_color p_l2">
                        <p class="font_14">合作院校</p>
                        <p class="font_14">{{count.schoolTotal}}</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="main width">
            <!-- <h1 class="font_30 m_b2 t_c">专业解决幼教实习就业招聘问题</h1> -->
            <h1 class="font_30 m_b2 t_c">专业解决实习生就业招聘问题</h1>
            <p class="label_p m_b4 t_c font_20">
                <!-- <span class="m_r1">海量幼教人才</span> -->
                <span class="m_r1">海量人才</span>
                /
                <span class="m_l1 m_r1">精准匹配</span>
                /
                <span class="m_l1 m_r1">用心服务</span>
                /
                <span class="m_l1">提升工作效率</span>
            </p>

            <div class="fwys width">
                <ul class="fwys_ul clearfix">
                    <li :class="{active: (index === idx), 'f_l': true, 'm_r1': true}" v-for="(item, idx) in yxfwList"
                        :key="idx" @mouseenter="mouseenter(idx)" @mouseleave="mouseleave">
                        <div class="fwys_img1"
                             :style="{backgroundImage: 'url('+ item.img + ')', backgroundPosition: 'center center', backgroundRepeat: 'no-repeat'}"></div>
                        <div class="fwys_title font_20 t_c m_b2">{{item.title}}</div>
                        <p class="font_16 justify">{{item.content}}</p>
                    </li>
                </ul>
            </div>

        </div>

        <div class="hzlc_con">
            <div class="hzlc_box">
                <div class="hzlc width">
                    <h1 class="font_30 m_b4 t_c">合作流程</h1>
                    <div class="hzlc_ul clearfix box_sizing">
						<div class="hzlc_ul_item">
							<template v-for="(item, index) in hzlcList">
								<div class="hzlc_li" v-if="index<=2" :key="index">
									<!-- 右侧弧线 -->
									<img class="hzlc_line" v-if="item.showLine" src="../assets/image/line.png" alt="">
									<div class="hzlc_img m_b2"
									     :style="{backgroundImage: 'url(' + item.img + ')', backgroundPosition: 'center center', backgroundRepeat: 'no-repeat'}"></div>
									<h3 class="font_20 m_b2 t_c">{{item.title}}</h3>
									<p class="font_16" v-if="item.con1">
									    <span></span>
									    <span> {{item.con1}}</span>
									</p>
									<p class="font_16" v-if="item.con2">
									    <span></span>
									    <span>{{item.con2}}</span>
									</p>
									<p class="font_16" v-if="item.con3">
									    <span></span>
									    <span> {{item.con3}}</span>
									</p>
								</div>
							</template>
						</div>
						<div class="hzlc_ul_item">
							<template v-for="(item, index) in hzlcList">
								<div class="hzlc_li" v-if="index>2" :key="index">
									<!-- 右侧弧线 -->
									<img class="hzlc_line" v-if="item.showLine" src="../assets/image/line.png" alt="">
									<div class="hzlc_img m_b2"
									     :style="{backgroundImage: 'url(' + item.img + ')', backgroundPosition: 'center center', backgroundRepeat: 'no-repeat'}"></div>
									<h3 class="font_20 m_b2 t_c">{{item.title}}</h3>
									<p class="font_16" v-if="item.con1">
									    <span></span>
									    <span> {{item.con1}}</span>
									</p>
									<p class="font_16" v-if="item.con2">
									    <span></span>
									    <span>{{item.con2}}</span>
									</p>
									<p class="font_16" v-if="item.con3">
									    <span></span>
									    <span> {{item.con3}}</span>
									</p>
								</div>
							</template>
						</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="keyword width" style="opacity: 0">
            <strong class="m_r2">奕杰</strong>
            <strong class="m_r2">奕杰阳光</strong>
            <strong class="m_r2">奕杰平台</strong>
            <strong class="m_r2">学前教育</strong>
            <strong class="m_r2">幼教</strong>
            <strong class="m_r2">实习就业</strong>
            <strong class="m_r2">幼儿园</strong>
        </div>
    </div>
</template>

<script>
    // @ is an alias to /src
    // import NavBar from '@/components/Header.vue'
    import { ImgUrl } from '../api/common_api';
    import { homeCount } from '../api/api'

    export default {
        name: 'Home',
        components: {},
        data() {
            return {
                // 首页统计
                count:{},
                banner: ImgUrl + 'banner.png',
                imgList: [
                    {
                        src: require('@/assets/image/banner.png')
                    },
                    // {
                    //     src: require('@/assets/image/banner_byy.png')
                    // }
                ],
                hzlcList: [
                    {
                        // img: '../assets/image/home_hzlc1.png',
                        img: require('@/assets/image/home_hzlc1.png'),
                        title: "岗前培训",
                        // con1: '> 培训幼儿园工作时需要注意的内容，如何与家长沟通，如何避免教态问题等；',
                        // con2: '> 到工作单位，需要提前做的准备等。',
                        con1: '培训入职企业工作时需要注意的内容；',
                        con2: '到工作单位，需要提前做的准备等；',
                        con3: '',
                        showLine:true
                    },
                    {
                        img: require('../assets/image/home_hzlc2.png'),
                        title: "简历提交",
                        // con1: '>·线上提交简历；',
                        con1: '线上提交简历，简历内容要求真实有效；',
                        // con2: '> 审核通过后方可查看企业相关信息。',
                        con2:'审核通过后即可查看企业相关信息并投递；',
                        con3: '',
                        showLine:true
                    },
                    {
                        img: require('../assets/image/home_hzlc3.png'),
                        title: "企业匹配",
                        // con1: '> 学生线上选择幼儿园，向园所投递简历；',
                        // con2: '> 幼儿园挑选学生简历；',
                        // con3: '> 双方线上匹配成功。',
                        con1: '学生线上选择企业，向企业投递简历；',
                        con2: '企业挑选学生简历，也可以邀请学生投递该企业；',
                        con3: '双方线上匹配成功；',
                    },
                    {
                        img: require('../assets/image/home_hzlc4.png'),
                        // title: "抵达园所",
                        title: "抵达企业",
                        // con1: '> 由学校统一时间或者学生自主确定时间，到达指定地点，由奕杰阳光老师和幼儿园老师共同接站，直接入园。',
                        con1: '由企业统一时间或学生自主确定时间，到达指定地点；',
                        con2: '由奕杰阳光老师和企业负责人共同接站，直接入职；',
                        con3: '',
                        showLine:true
                    },
                    {
                        img: require('../assets/image/home_hzlc5.png'),
                        title: "企业回访",
                        // con1: '> 奕杰老师辅助学校对学生进行定期回访，配合学校签署三方协议或实习报告等事宜。',
                        con1: '奕杰老师辅助学校对学生进行定期回访；',
                        con2: '配合学校签署三方协议或实习报告等事宜；',
                        con3: '',
                        showLine:true
                    },
                    {
                        img: require('../assets/image/home_hzlc6.png'),
                        title: "问题提交及反馈",
                        // con1: '> 幼儿园或者学生有问题时随时线上提交问题，由奕杰阳光专业老师协调处理，必要时现场进行核实或者调园，处理结果及时线上反馈。',
                        con1: '企业或者学生有问题可随时线上提交问题， 由奕杰阳光专业老师协调处理；',
                        con2: '必要时现成进行核实，处理结果及时线上反馈；',
                        con3: '',
                    },
                ],	//合作流程
                index: -1,
                yxfwList: [
                    {
                        img: require('@/assets/image/home_xssx.png'),
                        title: '线上招聘双选',
                        // content: '对于企业，实现专业线上幼教招聘，精准匹配，提高招聘、上岗进度。'
                        content:'对于企业，实现专业线上招聘，精准匹配，提高招聘、上岗进度。'
                    },
                    {
                        img: require("@/assets/image/home_sxgl.png"),
                        title: 'APP实习管理',
                        content: '结合学生实习期间的工作、学习情况，线上自动生成实习报告，这是一款针对院校实习与就业的平台管理。'
                    },
                    {
                        img: require('@/assets/image/home_sxjd.png'),
                        title: '让实习变的更简单',
                        // content: '入职之前可知晓就职园所，直接上岗。我们有专业团队解决实习就业问题。'
                        content:'入职之前可知晓就职企业，直接上岗。我们有专业团队解决实习就业问题。'
                    },
                ],
            };
        },
        created() {
            console.log(process.env)
            homeCount().then(res=>{
                // console.log(res);
                if(res.rescode==200){
                    this.count = res.data
                }else{
                    this.$message({
                        type: 'error',
                        message: '系统异常请稍后!'
                    })
                }
            }).catch(error=>{
                this.$message({
                    type: 'error',
                    message: '系统异常请稍后!'
                })
            })
        },
        methods: {
            mouseenter(idx) {
                this.index = idx
            },
            mouseleave() {
                this.index = -1
            },
        },
    };
</script>

<style scoped lang="stylus">
    $gray_color = #666666
    $red_color = #f16765
    .home {
        min-height calc(100vh - 283px)

        .banner_box {
            position relative

            .el-carousel__item a {
                display inline-block
                width 1920px
                height 100%
                min-width 1200px
                background-position: center center
                background-size cover
                background-repeat no-repeat
            }

            .home_label {
                width 100%
                padding 15px 0
                // background-color rgba(0, 0, 0, 0.18)
                background-color rgba(0, 0, 0, 0.4)
                position absolute
                bottom 0
                left 0
                z-index 90

                .label {
                    width 100%
                    height 100%
                    padding 0 100px
                    box-sizing border-box
                    display flex
                    align-items: center
                    justify-content: center

                    .label_item {
                        // flex 1
                        border-left 2px solid #fff;
                        display flex
                        // align-items: center
						flex-direction column;
                        p:nth-child(1){
                            margin-right 10px
                            display flex
							// margin-bottom 6px;
							font-size 12px;
                        }
						p:nth-child(2){
							font-size 25px;
						}
                        
                    }
                    .label_item:nth-child(2) {
                        margin 0 350px
                    }
                }
            }
        }

        .main {
            > h1 {
                margin-top: 80px
            }

            .label_p {
                color $gray_color
            }

            .fwys {
                margin-top 100px

                .fwys_ul {
                    margin-bottom 100px

                    .active {
                        border-bottom 10px solid $red_color
                        transform translateY(-5px)
                        transition all 0.2s
                    }

                    li {
                        width 366px
                        height 322px
                        position relative
                        padding 100px 50px 30px
                        box-sizing border-box
                        box-shadow: 4px 6px 24px 0 rgba(8, 8, 11, 0.2);
                        margin-right 50px

                        .fwys_img1,
                        .fwys_img2,
                        .fwys_img3,
                        .fwys_img4 {
                            width 100px
                            height 100px
                            border-radius 50%
                            position absolute
                            top -50px
                            left 0
                            right 0
                            margin-left auto
                            margin-right auto
                        }

                        p {
                            color $gray_color
                            text-align justify
                            font-family 'Microsoft YaHei'
                            font-style normal
                            font-weight 400
                            // font-size 12px
                            line-height 20px

                        }

                        &:last-child {
                            margin-right 0
                        }
                    }
                }
            }


            /*.app_section {
                .app_desc {
                    position: relative;
                    box-shadow 0 0 20px rgba(0, 0, 0, 0.06)
                    margin-right 87px

                    &:last-child {
                        margin-right 0
                    }

                    span {
                        color $gray_color
                    }

                    img {
                        width 300px
                        height 300px
                    }
                }

                .app_desc:before, .app_desc:after {
                    content: "";
                    display: block;
                    width: 0;
                    height: 0;
                    border: 2px solid transparent;
                    box-sizing: border-box;
                    position: absolute;
                }

                .app_desc:before {
                    top: 0;
                    left: 0;
                    transition: border-color 0s ease-in 0.8s, width 0.2s ease-in 0.6s, height 0.2s ease-in 0.4s;
                }

                .app_desc:after {
                    right: 0;
                    bottom: 0;
                    transition: border-color 0s ease-in 0.4s, width 0.2s ease-in 0.2s, height 0.2s ease-in;
                }

                .app_desc:hover:before {
                    width: 100%;
                    height: 100%;
                    transition: width 0.2s ease-in, height 0.2s ease-in 0.2s;
                    border-top-color: #f16765;
                    border-right-color: #f16765;
                }

                .app_desc:hover:after {
                    width: 100%;
                    height: 100%;
                    transition: border-color 0s ease-in 0.4s, width 0.2s ease-in 0.4s, height 0.3s ease-in 0.6s;
                    border-bottom-color: #F16765;
                    border-left-color: #F16765;
                }
            }*/

        }

        .hzlc_con {
            width 100%
            overflow hidden
            /*padding-top 140px*/

            .hzlc_box {

                .hzlc {
                    > h1 {
                        /*margin-top: 100px*/
                        margin-bottom 80px
                    }

                    .hzlc_ul {
                        padding 0 30px;
						.hzlc_ul_item{
							width 100%
							display: -webkit-flex;
							display: -ms-flexbox;
							display: flex;
							-webkit-flex-wrap: wrap;
							-ms-flex-flow: row wrap;
							flex-wrap: wrap;
						}
                        .hzlc_li {
                            flex 1
                            // width 220px
                            height 420px
                            // margin-right 240px
                            margin-right 88px
                            display flex
                            flex-direction: column
                            align-items: center
                            position relative
                            .hzlc_line{
                                position absolute
                                right -110px
                                top 23%
                                width 146px
                                height 26px
                            }
                            &:nth-of-type(3n) {
                                margin-right 0
                            }

                            .hzlc_img {
                                width 220px
                                height 188px
								margin-right:20%;
                                // margin-left 15px

                                &:hover {
                                    transform: rotate(-10deg);
                                    -ms-transform: rotate(-10deg); /* IE 9 */
                                    -webkit-transform: rotate(-10deg); /* Safari and Chrome */
                                    transition all 0.2s cubic-bezier(.86, 0, .07, 1)
                                }
                            }

                            p {
                                color $gray_color
                                line-height 24px
                                text-align justify
                                text-justify: distribute
                                margin-left 10px
                                display flex
                                width 100%
                                span {
                                    display inline-block
                                    line-height: 30px
                                }
                                span:nth-child(1) {
                                    position relative
                                    top 12px
                                    width 5px
                                    height 5px
                                    background-color #726f6f
                                    border-radius 50%
                                    margin-right 10px
                                    
                                }
                                span:nth-child(2) {
                                    flex 1
                                    white-space wrap
                                }
                            }
                        }
                    }
                }
            }
        }

    }
</style>
